module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.y === 'top',
      "bottom": _vm.y === 'bottom',
      "right": _vm.x === 'right',
      "left": _vm.x === 'left',
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding-top": "5px"
    },
    attrs: {
      "id": "conditionsInput"
    }
  }, [_c('label', [_vm._v("Enter Condition")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.checked,
      "id": "input",
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Search condition (E.g. Treacher Collins Syndrome)"
    },
    on: {
      "focus": _vm.ClearInputForNewSearch,
      "keydown": _vm.EnterForSearch
    }
  }), _vm._v(" "), _c('typeahead', {
    attrs: {
      "match-start": "",
      "target": "#input",
      "data": _vm.DiseaseNames,
      "limit": parseInt(100),
      "preselect": false,
      "item-key": "DiseaseName"
    },
    on: {
      "keydown": _vm.EnterForSearch
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btnColor",
    staticStyle: {
      "margin-top": "-0.35px",
      "text-transform": "none"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkBeforePerformSearch($event)
      }
    }
  }, [_vm._v("\n      Generate Gene List\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-menu', {
    staticStyle: {
      "box-shadow": "0 6px 12px rgba(0,0,0,.175)",
      "border-radius": "4px",
      "border": "1px solid rgba(0,0,0,.15)"
    },
    attrs: {
      "bottom": "",
      "offset-y": ""
    },
    model: {
      value: (_vm.singleItemTypeAhead),
      callback: function($$v) {
        _vm.singleItemTypeAhead = $$v
      },
      expression: "singleItemTypeAhead"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), (_vm.singleItemTypeAhead) ? _c('v-list', [_c('v-list-tile', {
    staticStyle: {
      "background": "#4267b2",
      "height": "26px",
      "min-width": "140px"
    },
    on: {
      "click": function($event) {}
    }
  }, [_c('li', {
    staticClass: "active",
    staticStyle: {
      "font-size": "14px",
      "margin-top": "-22px",
      "color": "white"
    }
  }, [_c('span', [_vm._v("Search on: "), _c('strong', [_vm._v(_vm._s(_vm.search))])])]), _c('hr')])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.multipleSearchTerms.length) ? _c('div', [_c('br'), _vm._v("\n        Conditions Searched:\n        "), _vm._l((_vm.multipleSearchTerms), function(searchItem, i) {
    return _c('span', {
      attrs: {
        "id": "conditionChips"
      }
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "z-index": [_vm.tooltipDefinition === null ? '-1' : '4']
      }
    }, [_c('v-chip', {
      key: i,
      attrs: {
        "slot": "activator",
        "disabled": "",
        "color": "primary",
        "text-color": "white",
        "close": ""
      },
      on: {
        "input": function($event) {
          _vm.remove(searchItem)
        },
        "mouseover": function($event) {
          _vm.showTooltip(searchItem)
        },
        "mouseout": function($event) {
          _vm.hideToolTip(searchItem)
        }
      },
      slot: "activator"
    }, [_vm._v("\n              " + _vm._s(i + 1) + ". " + _vm._s(searchItem) + "\n            ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tooltipDefinition !== null),
        expression: "tooltipDefinition!== null"
      }]
    }, [_c('div', {
      staticStyle: {
        "width": "600px"
      },
      model: {
        value: (_vm.tooltipDefinition),
        callback: function($$v) {
          _vm.tooltipDefinition = $$v
        },
        expression: "tooltipDefinition"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.tooltipDefinition) + "\n              ")])])], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.checked) ? _c('p', [_c('v-progress-linear', {
    attrs: {
      "height": "3",
      "color": "primary",
      "indeterminate": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('v-alert', {
    attrs: {
      "color": "warning",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n      Sorry, the following search term returns no gene panels! "), _c('a', {
    on: {
      "click": _vm.searchInPhenolyzer
    }
  }, [_c('strong', [_vm._v(" Try in Phenolyzer")])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "warning",
      "dismissible": ""
    },
    model: {
      value: (_vm.alertWarning),
      callback: function($$v) {
        _vm.alertWarning = $$v
      },
      expression: "alertWarning"
    }
  }, [_vm._v("\n      Sorry, we are unable to fetch data for this term! "), _c('a', {
    on: {
      "click": _vm.searchInPhenolyzer
    }
  }, [_c('strong', [_vm._v(" Try in Phenolyzer")])])]), _vm._v(" "), (_vm.alertWarningHints && _vm.warningHints.length > 0) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "outline": "",
      "dismissible": ""
    },
    model: {
      value: (_vm.alertWarningHints),
      callback: function($$v) {
        _vm.alertWarningHints = $$v
      },
      expression: "alertWarningHints"
    }
  }, [_vm._v("\n      Sorry, This search term is too general. Please try a more specific term. "), _c('br'), _c('br'), _vm._v(" Example: "), _vm._l((_vm.warningHints), function(hint, i) {
    return (_vm.warningHints.length > 0) ? _c('li', {
      key: i,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInputValueFromHint(hint)
        }
      }
    }, [_vm._v(" " + _vm._s(hint.Title) + " ")]) : _vm._e()
  })], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c1e470","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/DisorderSearch.vue
// module id = 507
// module chunks = 0